import type {
  AnnouncementBuildRange,
  AnnouncementCampaignDraft,
  AnnouncementCampaignView,
  AnnouncementDryRun,
} from "@care-by-ella/contracts";
import { API_BASE, apiFetch, tenantHeader, withCredentials } from "./api";
import { commonHeaders, jsonOr401 } from "./clinician-api";

// TES-1676 — the client for "Utskick" (admin-only endpoints).

const BASE = `${API_BASE}/employee-api/v1/announcement-campaigns`;

export async function fetchCampaigns(): Promise<AnnouncementCampaignView[]> {
  const res = await apiFetch(BASE, {
    headers: tenantHeader(),
    ...withCredentials,
  });
  return jsonOr401(res);
}

export async function fetchDryRun(
  range: AnnouncementBuildRange,
): Promise<AnnouncementDryRun> {
  const q = new URLSearchParams();
  if (range.minAppVersion) q.set("minAppVersion", range.minAppVersion);
  if (range.maxAppVersion) q.set("maxAppVersion", range.maxAppVersion);
  const res = await apiFetch(`${BASE}/dry-run?${q.toString()}`, {
    headers: tenantHeader(),
    ...withCredentials,
  });
  return jsonOr401(res);
}

export async function saveCampaign(
  id: string | null,
  draft: AnnouncementCampaignDraft,
): Promise<AnnouncementCampaignView> {
  const res = await apiFetch(id ? `${BASE}/${id}` : BASE, {
    method: id ? "PUT" : "POST",
    headers: commonHeaders(),
    body: JSON.stringify(draft),
    ...withCredentials,
  });
  return jsonOr401(res);
}

export async function sendCampaign(
  id: string,
  confirmKey: string,
): Promise<AnnouncementCampaignView> {
  const res = await apiFetch(`${BASE}/${id}/send`, {
    method: "POST",
    headers: commonHeaders(),
    body: JSON.stringify({ confirmKey }),
    ...withCredentials,
  });
  return jsonOr401(res);
}
